// extracted by mini-css-extract-plugin
module.exports = {"group":"ProductSalesVolume_group_o8tOC"};